import { render, staticRenderFns } from "./SearchUser.vue?vue&type=template&id=0b26540b&"
import script from "./SearchUser.vue?vue&type=script&lang=js&"
export * from "./SearchUser.vue?vue&type=script&lang=js&"
import style0 from "./SearchUser.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports